import Vue from 'vue'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import store from '@/store/store'
import enMessage from '@/locales/en'
import idMessage from '@/locales/id'

export const i18n =  new VueI18n({
  locale: store.state.appUser.locale || 'en',
  fallbackLocale: 'en',
  messages: {
    en : enMessage,
    id : idMessage,
  }
})
